import React, { useCallback, useState } from "react"
import LightBox from "~/app/common/LightBox";
import classNames from "classnames";
import classes from './style.module.scss';

export interface LightBoxImageProps {
    image: string
    className?: string
    download?: boolean
}

export type LightBoxImageComponent = React.FC<LightBoxImageProps>

const LightBoxImage: LightBoxImageComponent = ({className, image, download = false}) => {
    const [flexBoxOpen, setFlexBoxOpen] = useState<boolean>(false);

    const toggleFlexBox = useCallback(() => {
        setFlexBoxOpen(prev => !prev);
    }, []);

    return (
        <>
            <img src={image} alt='' className={classNames(classes['image'], className)} onClick={toggleFlexBox} />
            <LightBox className={classes['light-box-image']} open={flexBoxOpen} onClose={toggleFlexBox} imageUrl={image} download={download} />
        </>
    )
}

export default LightBoxImage